export default __webpack_public_path__ + "static/media/pokiPort@3x.46bc25b5.png";